// src/services/api.js — añadir ratesAPI al final

import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://api.guarapo.app',
  timeout: 15000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export const authAPI = {
  login: (email, password) =>
    api.post('/api/v1/auth/login', new URLSearchParams({ username: email, password })),
  register: (data) => api.post('/api/v1/auth/register', data),
  me: () => api.get('/api/v1/auth/me'),
};

export const txAPI = {
  create: (data) => api.post('/api/v1/transactions/', data),
  list: (params) => api.get('/api/v1/transactions/', { params }),
  get: (ref) => api.get(`/api/v1/transactions/${ref}`),
};

export const contactsAPI = {
  list: () => api.get('/api/v1/contacts/'),
  create: (data) => api.post('/api/v1/contacts/', data),
  delete: (id) => api.delete(`/api/v1/contacts/${id}`),
};

export const agentsAPI = {
  list: () => api.get('/api/v1/agents/'),
  offlineQueues: () => api.get('/api/v1/agents/offline-queues'),
  heartbeat: () => api.post('/api/v1/agents/heartbeat'),
  goOffline: () => api.post('/api/v1/agents/offline'),
};

export const complianceAPI = {
  alerts: () => api.get('/api/v1/compliance/alerts'),
  resolve: (id, resolution) =>
    api.post(`/api/v1/compliance/alerts/${id}/resolve`, { resolution }),
};

// ── RATES (nuevo) ────────────────────────────────────────────────────────────
export const ratesAPI = {
  get: () => api.get('/api/v1/rates/'),
};

export const p2pAPI = {
  listOffers:  (params)     => api.get('/api/v1/p2p/offers', { params }),
  myOffers:    ()           => api.get('/api/v1/p2p/offers/mine'),
  getOffer:    (id)         => api.get(`/api/v1/p2p/offers/${id}`),
  createOffer: (data)       => api.post('/api/v1/p2p/offers', data),
  updateOffer: (id, data)   => api.patch(`/api/v1/p2p/offers/${id}`, data),
  quoteOffer:  (id, amount) => api.post(`/api/v1/p2p/offers/${id}/quote`, { amount }),
  takeOffer:   (id, data)   => api.post(`/api/v1/p2p/offers/${id}/take`, data),
};

export default api;
